module.exports = __webpack_public_path__ + "media/mypage/images/icons/icon_msg-420d89e3ea4af70e37a7fd19adca2846.png";